import React from 'react'
import * as moment from 'moment'
import useOnConstrainConstraint from 'support/hooks/use-on-constrain-constraint'
import { Translation } from '@morningtrain/react-translations'
import TranslatedTitle from 'widgets/TranslatedTitle'

export default function CalendarPeriod () {
  const [month, setMonth] = React.useState(moment().month())

  useOnConstrainConstraint('month', (constraints) => {
    setMonth(constraints.get('month').month)
  })

  const [date, setDate] = React.useState(moment())

  React.useEffect(() => {
    const newDate = date.clone()
    newDate.month(month)
    setDate(newDate)
  }, [month])

  return (
    <>
      <TranslatedTitle name='special_days.title' />
      {date ? (<span> - {date.format('MMMM')}</span>) : null}
    </>
  )
}
